import Image from 'next/image';
import React, {useState, useEffect }from 'react';
import SectionHeading from '../../Common/SectionHeading';
import CommonPopup from '../../PopupForm/CommonPopup';
import * as Yup from 'yup';
import dynamic from 'next/dynamic';

// import { useFormik } from 'formik';
// import Captcha from "../../Captcha/Captcha";
import { useCreateItemMutation } from '../../../components/Store/Features/CommonAPI';
import { useRouter } from 'next/navigation';



const LeverageSection = ({title=null}) => {

  const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };
    
    const closeModal = () => {
        setIsModalOpen(false);
    };
  
  const options = {
    btn_name: "Submit"
  }
  const phoneRegExp = /^(\+\d{1,4})?(\d{9,14})$/

  const fields = [
    {
        name: 'name',
        label: '',
        placeholder: 'Full Name*',
        validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
        customClass: 'md:col-span-6 col-span-12'
    },
    {
        name: 'email',
        type: 'email',
        label: '',
        placeholder: 'Add Your Company E-mail Address*',
        validation: Yup.string().email('Invalid email').required('Email is required'),
        customClass: 'md:col-span-6 col-span-12'
    
    },
    {
        name: 'company_name',
        label: '',
        placeholder: 'Company Name',
        customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'phone',
      label: '',
      placeholder: 'Phone Number',
      validation: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
      customClass: 'md:col-span-6 col-span-12'
    }
  ];
  return (
    <section className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-8 my-4">
      <div className="grid grid-cols-12 gap-8 mb-8" style={{ backgroundImage: `url(${process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/background_dots_02.jpg'})`, backgroundPosition: '0px', backgroundSize: '138%' }}>
        <div className="lg:col-span-7 col-span-12">
          <Image 
            priority={false} 
            src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/leverage-our-competitive-intelligence-services.png'} 
            width={2000} 
            height={2000} 
            className="hidden lg:block" 
            alt="Leverage our Competitive Intelligence Services"
          />
        </div>
        <div className="lg:col-span-5 col-span-12 pr-0">
          {(title) &&
              <SectionHeading title={title}  customClass="text-center lg:text-left"/>
          }
          <ul>
              <li className="list-ouside"><span className="fa fa-check pr-4 py-2" style={{ color: '#2177e9' }}></span>Develop better R&D strategies</li>
              <li className="list-ouside"><span className="fa fa-check pr-4 py-2" style={{ color: '#2177e9' }}></span>Gain in-depth understanding of unexplored markets</li>
              <li className="list-ouside"><span className="fa fa-check pr-4 py-2" style={{ color: '#2177e9' }}></span>Develop a robust marketing strategy</li>
              <li className="list-ouside"><span className="fa fa-check pr-4 py-2" style={{ color: '#2177e9' }}></span>Conduct effective due-diligence</li>
              <li className="list-ouside"><span className="fa fa-check pr-4 py-2" style={{ color: '#2177e9' }}></span>Keep abreast of challenges</li>
              <li className="list-ouside"><span className="fa fa-check pr-4 py-2" style={{ color: '#2177e9' }}></span>Create a proactive approach to tackle changes</li>
          </ul>
          <div className="text-center md:text-left">
              <button onClick={openModal} className="bg-blue-500 text-white px-4 py-2 mt-4 rounded hover:bg-blue-600">
                  Request For Call
              </button>
              <CommonPopup isOpen={isModalOpen} closeModal={closeModal} 
                  fields={fields}
                  options={options}
                  page_name="Primary Research Page"
                  form_name="primary-res-page-form"
                  formTitle="Request For Call"
                  endpoint="/enquiry/request-for-call"
              />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-4">
        <div className="lg:col-span-4 col-span-12">
          <div className="card card-block p-4 border">
            <Image 
              priority={false} 
              src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/clinical-trial-monitoring.png'} 
              width={2000} 
              height={2000} 
              alt="Clinical Trial Monitoring" 
            />
            <h3 className="pt-5 text-xl font-semibold">Clinical Trial Monitoring</h3>
            <p className="line-clamp-2">Assessing clinical trial changes of immune checkpoint inhibitors in the Rheumatology space</p>
          </div>
        </div>
        <div className="lg:col-span-4 col-span-12">
          <div className="card card-block p-4 border">
            <Image 
              priority={false} 
              src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/periodic-cI-tracking.png'} 
              width={2000} 
              height={2000} 
              alt="Periodic CI Tracking" 
            />
            <h3 className="pt-5 text-xl font-semibold">Periodic CI Tracking</h3>
            <p className="line-clamp-2">Newsletter-based CI Tracking of PD-1 assets in gynecological cancers</p>
          </div>
        </div>
        <div className="lg:col-span-4 col-span-12">
          <div className="card card-block p-4 border">
            <Image 
              priority={false} 
              src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/therapy-intelligence.png'} 
              width={2000} 
              height={2000} 
              alt="Therapy Intelligence" 
            />
            <h3 className="pt-5 text-xl font-semibold">Therapy Intelligence</h3>
            <p className="line-clamp-2">Monitoring clinical & regulatory developmental milestones for the treatment of degenerative disorders</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeverageSection;